import React from 'react';
import { useNavigate } from 'react-router-dom';
import Panel from './components/Panel';
import MapView from './components/MapView';
import OrderList from './components/OrderList';
import AlertList from './components/AlertList';
import CompletionStats from './components/CompletionStats';
import ServiceMonitor from './components/ServiceMonitor';
import BabyMonitor from './components/BabyMonitor';
import BusinessData from './components/BusinessData';
import ServiceAlert from './components/ServiceAlert';
import DeviceStatus from './components/DeviceStatus';
import MonitoringAlert from './components/MonitoringAlert';
import WeatherWidget from './components/WeatherWidget';
import RoomStaffStats from './components/RoomStaffStats';
import NewOrders from './components/NewOrders';

function Dashboard({ storeId }) {
  const navigate = useNavigate();

  return (
    <div className="dashboard">
      {/* 顶部统计卡片 */}
      <div className="stats-row">
        <WeatherWidget storeId={storeId} />
        <DeviceStatus storeId={storeId} />
        <MonitoringAlert storeId={storeId} />
        <ServiceAlert storeId={storeId} />
        <NewOrders storeId={storeId} />
      </div>

      <div className="middle-row">
        <div className="map-panel-container">
          <Panel title="婴儿监控" className="baby-monitor-panel">
            <BabyMonitor storeId={storeId} />
          </Panel>
          <Panel title="婴儿护理监控" className="map-panel-inner">
            <MapView storeId={storeId} />
          </Panel>
        </div>

        <div className="center-charts">
          <Panel title="婴儿告警信息" className="chart-panel-container">
            <AlertList title="实时告警" storeId={storeId} />
          </Panel>
          <div className="charts-row">
            <Panel title="服务监控" className="small-chart">
              <ServiceMonitor />
            </Panel>
          </div>
        </div>

        <div className="right-panels">
          <Panel
            title="经营数据"
            className="pie-panel"
            extra={(
              <span className="panel-view-more" onClick={() => navigate('/client/commandCenter')}>
                查看更多 ›
              </span>
            )}
          >
            <BusinessData storeId={storeId} />
          </Panel>
          <Panel title="订单列表" className="data-list-panel">
            <OrderList storeId={storeId} />
          </Panel>
          <Panel title="房间及人员统计" className="room-staff-panel">
            <RoomStaffStats storeId={storeId} />
          </Panel>
        </div>
      </div>

      {/* 底部完成率统计 */}
      <CompletionStats storeId={storeId} />
    </div>
  );
}

export default Dashboard;
